export type ConditionKey = "new" | "p_discount" | "refurbished" | "used" | "w_undetermined"
export type ConditionValue = 0 | 1 | 2 | 3 | 4 | 5

export type PaginationState = {
  current: number
  total: number
}

export enum TaskStatus {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
  REVOKED = "REVOKED",
  STARTED = "STARTED",
  RECEIVED = "RECEIVED",
  REJECTED = "REJECTED",
  RETRY = "RETRY",
  PENDING = "PENDING"
}
